module.exports = __webpack_public_path__ + "img/check.b6962dfb.svg";